import React from "react";
import { useT } from "../lib/i18n";
import { track } from "../lib/analytics";

/**
 * Compact BM/EN language toggle. Two-state pill; keeps current visual style.
 */
export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang, t } = useT();
  const change = (next) => {
    if (next === lang) return;
    setLang(next);
    track("language_changed", { to: next });
  };
  const btn = (code, flag, label) => {
    const active = lang === code;
    return (
      <button
        key={code}
        data-testid={`lang-${code}`}
        onClick={() => change(code)}
        className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
          active
            ? "bg-[#0A2540] text-white"
            : "bg-transparent text-[#0A2540] hover:bg-[#F5F5F7]"
        }`}
        aria-pressed={active}
        title={label}
      >
        <span className="mr-1">{flag}</span>
        {code.toUpperCase()}
      </button>
    );
  };
  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-1 bg-white/70 backdrop-blur border border-[#E8E8ED] rounded-full p-0.5 ${className}`}
      role="group"
      aria-label={t("topbar.language")}
    >
      {btn("ms", "🇲🇾", "Bahasa Melayu")}
      {btn("en", "🇬🇧", "English")}
    </div>
  );
}
